export const divVariants = {
  hidden: {},
  visible: {},
  exit: {}
};

export const fadeVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 }
};
export const fadeDelayVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.6
    }
  },
  exit: { opacity: 0 }
};

export const heartBeatVariants = {
  hidden: {},
  visible: {
    scale: [1, 1.3, 1, 1.3, 1],
    transition: {
      repeat: Infinity,
      repeatType: "reverse",
      duration: 0.7,
      repeatDelay: 2
    }
  },
  exit: {}
};

export const bounceVariants = {
  hidden: { x: "100vw" },
  visible: { x: 0 },
  exit: { x: "-100vw" }
};

export const bounceRightVariants = {
  hidden: { x: "100vw" },
  visible: { x: 0 },
  exit: { x: "100vw" }
};

export const bounceRightExitVariants = {
  exit: { x: "100vw" }
};

export const bounceLeftVariants = {
  hidden: { x: "-100vw" },
  visible: { x: 0 },
  exit: { x: "-100vw" }
};

export const bounceLeftExitVariants = {
  exit: { x: "-100vw" }
};

export const slideHorizontalLeftVariants = {
  hidden: { x: "-100vw" },
  visible: {
    x: 0,
    transition: {
      bounce: 0,
      duration: 0.4
    }
  }
};

export const slideHorizontalLeftExitVariants = {
  exit: { x: "-100vw" }
};
export const slideHorizontalRightVariants = {
  hidden: { x: "100vw" },
  visible: {
    x: 0,
    transition: {
      bounce: 0,
      duration: 0.4
    }
  }
};

export const slideStaticVariants = {
  visible: { x: 0 }
};
export const slideHorizontalRightExitVariants = {
  exit: { x: "100vw" }
};

export const modalSlideVariants = {
  hidden: { y: "100vh" },
  visible: {
    y: 0,
    transition: {
      bounce: 0,
      when: "beforeChildren"
    }
  },
  exit: { y: "100vh" }
};

export const staticBounceVariants = {
  hidden: { scale: 0, opacity: 0 },
  visible: {
    opacity: 1,
    scale: [0.3, 1.15, 0.85, 1.1, 0.95],
    transition: { duration: 0.7 }
  },
  exit: {
    scale: [0.95, 0.85, 1.1, 0.2]
  }
};

export const logoVariants = {
  hidden: {
    y: "-100vh",
    opacity: 0.5,
    scale: 0.7
  },
  visible: {
    y: 0,
    opacity: 1,
    scale: 1,
    transition: {
      type: "tween",
      duration: 0.2,
      opacity: { delay: 0.2, duration: 0.3 },
      scale: { delay: 0.2, duration: 0.3 }
    }
  }
};

export const logoVariantsExit = {
  exit: {
    y: "-100vh",
    opacity: 0.5,
    scale: 0.7,
    transition: {
      type: "tween",
      duration: 0.5,
      opacity: { duration: 0.3 },
      scale: { duration: 0.3 },
      y: { delay: 0.3 }
    }
  }
};

export const zoomVariants = {
  hidden: { opacity: 0.4, scale: 0.2 },
  visible: {
    opacity: 1,
    scale: 1
  },
  exit: { opacity: 0, scale: 0.2 }
};
